import React from 'react';
import moment from 'moment';
import PropTypes from 'prop-types';

import {
  CardClipFooter,
  ContainerCardClip,
  DateCard,
  TitleCard,
} from './styles';

const CardHighlightReel = (props) => {
  const {
    highlightReel,
    onCardClick,
    selected,
    isSelectable,
  } = props;

  const {
    id,
    title,
    createdAt,
  } = highlightReel;

  return (
    <ContainerCardClip
      selected={selected}
      onClick={() => onCardClick(id)}
      isSelectable={isSelectable}
    >
      <TitleCard>
        {title}
      </TitleCard>

      <CardClipFooter>
        <DateCard>
          {moment(createdAt).format('ll')}
        </DateCard>

      </CardClipFooter>
    </ContainerCardClip>
  );
};

CardHighlightReel.propTypes = {
  highlightReel: PropTypes.object.isRequired,
  onCardClick: PropTypes.func,
  selected: PropTypes.bool,
  isSelectable: PropTypes.bool,
};

CardHighlightReel.defaultProps = {
  onCardClick: null,
  selected: false,
  isSelectable: false,
};

export default CardHighlightReel;
